

if(!customElements.get('product-bundles')) {
  customElements.define('product-bundles', class ProductBundles extends HTMLElement {
    connectedCallback() {
      this.init();
    }

    init() {
      this.options = this.querySelectorAll('[data-bundle-option]');
      if(this.options.length === 0) return;

      this.quantityInput = document.querySelector(`.quantity-selector-${this.id} input`);
      this.priceContainer = document.querySelector(`.product--${this.id} sale-price`);
      this.unitPriceContainer = document.querySelector(`.product--${this.id} unit-price`);
      this.setupEventListeners();
      this.onOptionClick();
    }

    setupEventListeners() {
      document.addEventListener('variant:change', (e) => {
        if (!e || !this.quantityInput || !e.detail.id.includes(this.id)) return;
        this.handleQuantityChange(Number(this.quantityInput.value));
      })

      document.addEventListener('quantity::changed', (e)=> {
        if(!e || !e.detail.id.includes(this.id)) return;
        this.handleQuantityChange(Number(e.detail.quantity));
      })
    }
  
    handleQuantityChange(quantity) {
      this.options.forEach(option => {
        option.classList.remove('active');

        const minBundleQuantity = Number(option.dataset.min);
        const maxBundleQuantity = Number(option.dataset.max);
        
        if(minBundleQuantity === maxBundleQuantity && quantity >= minBundleQuantity) {
          option.classList.add('active');
          this.priceContainer.innerText = option.dataset.price;
          if( this.unitPriceContainer) {
            this.unitPriceContainer.innerText = option.querySelector('.unit-price').innerText;
          }
        } else if(quantity >= minBundleQuantity && quantity <= maxBundleQuantity) {
          option.classList.add('active');
          this.priceContainer.innerText = option.dataset.price;
          if( this.unitPriceContainer) {
            this.unitPriceContainer.innerText = option.querySelector('.unit-price').innerText;
          }
        }
      });
    }

    onOptionClick() {
      this.options.forEach(option => {
        option.addEventListener('click', ()=> {
          this.options.forEach(option => option.classList.remove('active'));
          option.classList.add('active');
          this.priceContainer.innerText = option.dataset.price;
          if( this.unitPriceContainer) {
            this.unitPriceContainer.innerText = option.querySelector('.unit-price').innerText;
          }
          if(this.quantityInput) {
            this.quantityInput.value = option.dataset.min;
          }
        })
      })
    }
  })
}